import { useQuery } from '@tanstack/react-query'
import { useViewerCurrency } from '@/api/hooks/shared/useViewerCurrency'
import {
  loadCreditLimitTransfers,
  type CreditLimitLogSource,
} from './clTransfersData'
import type { CreditLimitTransferQuery } from './clTransfersTypes'

/**
 * CL Transfers — Winner credit-limit change log (PG today / BQ historical).
 *
 * Live → CM-API `searchCreditLimitLogs` (postgres) or `searchCreditLimitLogsBQ`.
 * Unreachable → unavailable (never invents rows).
 */
export function useCreditLimitTransfers(
  query: CreditLimitTransferQuery,
  source: CreditLimitLogSource = 'postgres',
) {
  const currency = useViewerCurrency()
  return useQuery({
    queryKey: ['cm', 'credit-limit-transfers', source, { ...query, currency }],
    queryFn: () => loadCreditLimitTransfers(query, currency, source),
    // No placeholder across date/source changes — stale rows looked like a broken filter.
    retry: false,
  })
}
